import type { NovelItem } from '@app/_proto/Protos/novels';

export type CollectionForLog = {
    collectionSlot?: number;
    collectionTitle: string;
    genre?: string;
};

export type CollectionParams = {
    collectionSlot?: number;
    itemSlot?: number;
    genre?: string;
};

export type CollectionItemForLog = CollectionForLog & {
    itemSlot?: number;
};

export enum PlacementId {
    Featured = 1,
    NewRelease = 2,
}

export type ContentWithGenre = { content: NovelItem | undefined; genre: string | undefined };
